/* Maison Hydria — affiche la valeur sélectionnée à côté du nom de l'option.
   Exemple rendu : « Couleur : Or ».

   Le thème n'affiche que le nom de l'option ; la valeur choisie n'apparaît nulle part.
   Ce script l'ajoute dans le même libellé, sur toutes les fiches produit et tous
   les modèles, sans modifier le bloc natif du sélecteur de variantes.

   Le thème remplace tout l'innerHTML du <variant-picker> à chaque changement :
   on réapplique donc l'affichage sur l'événement « variant:updated ».
*/
(function () {
  var SELECTEUR_GROUPE = 'variant-picker .variant-picker__option';

  function valeurSelectionnee(groupe) {
    var coche = groupe.querySelector('input[type="radio"]:checked');
    if (coche && coche.value) return coche.value;

    var liste = groupe.querySelector('select');
    if (liste && liste.value) return liste.value;

    return null;
  }

  function majGroupe(groupe) {
    var libelle = groupe.querySelector('.variant-picker__option-name');
    if (!libelle) return;

    var porteur = libelle.querySelector('span');
    if (!porteur) return;

    var valeur = valeurSelectionnee(groupe);
    if (!valeur) return;

    var cible = porteur.querySelector('[data-mh-valeur]');
    if (!cible) {
      cible = document.createElement('span');
      cible.setAttribute('data-mh-valeur', '');
      porteur.appendChild(document.createTextNode(' '));
      porteur.appendChild(cible);
    }
    if (cible.textContent !== valeur) cible.textContent = valeur;
  }

  function majTout() {
    document.querySelectorAll(SELECTEUR_GROUPE).forEach(majGroupe);
  }

  // Changement de variante : mise à jour immédiate du groupe concerné.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!(el instanceof HTMLElement)) return;
    var groupe = el.closest('.variant-picker__option');
    if (groupe && groupe.closest('variant-picker')) majGroupe(groupe);
  });

  // Le thème vient de re-rendre le sélecteur depuis le serveur.
  document.addEventListener('variant:updated', majTout);

  // Ouverture d'un ajout rapide, d'un tiroir, etc.
  document.addEventListener('cart:updated', majTout);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', majTout);
  } else {
    majTout();
  }

  // Filet de sécurité pour les sélecteurs injectés après coup.
  if (window.MutationObserver) {
    new MutationObserver(function () { majTout(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
